<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps<{
  error: NuxtError
}>()

console.error('Error details:', {
  statusCode: props.error.statusCode,
  statusMessage: props.error.statusMessage,
  message: props.error.message,
  stack: props.error.stack,
  cause: props.error.cause
})

const handleError = async () => {
  await clearError({ redirect: '/' })
}
</script>

<template>
  <div class="error-page">
    <h1>Ошибка {{ error.statusCode || 500 }}</h1>
    <p>{{ error.statusMessage || 'Внутренняя ошибка сервера' }}</p>
    <p v-if="error.message">{{ error.message }}</p>
    <pre v-if="error.stack">{{ error.stack }}</pre>
    <button @click="handleError">На главную</button>
  </div>
</template>

<style scoped>
.error-page {
  padding: 20px;
  text-align: center;
}

pre {
  text-align: left;
  background: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
  overflow: auto;
  max-height: 300px;
}

button {
  background: #0066cc;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 20px;
}
</style>
